import { Component } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutomaticBatchCreationComponent } from '../automatic-batch-creation/automatic-batch-creation.component';

@Component({
  selector: 'app-add-batch',
  templateUrl: './add-batch.component.html',
  styleUrls: ['./add-batch.component.css']
})
export class AddBatchComponent {
  displayedColumns: string[] = ['s_no', 'batchNumber', 'quantity', 'batch_attribute_1', 'batch_attribute_2', 
  'admission_date', 'manufacturing_date', 'expiration_date'];
 dataSource : any = [{
  }];

  constructor(public dialog: MatDialog,) {

    }
  
openDialog(): void {
    this.dialog.open(AutomaticBatchCreationComponent, {
  }); 
}


}
